import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BFXAppNotificationType, BFXNotificationType } from "shared/cubiq-services";
export const VALID_EMAIL: any =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const VALID_SMS_NUMBER: any = /^\+?[0-9]+$/;
export const OBJECT_SORT: any = (a, b) => {
  return a.label.toLowerCase() < b.label.toLowerCase()
    ? -1
    : a.label.toLowerCase() > b.label.toLowerCase()
    ? 1
    : 0;
};
export const FILTER_SORT: any = (a, b) => {
  return a.name.toLowerCase() < b.name.toLowerCase()
    ? -1
    : a.name.toLowerCase() > b.name.toLowerCase()
    ? 1
    : 0;
};
export const NONE_SOUND: any = { label: "None", value: "None" };
export const NONE_FILTER: any = { name: "None", id: -1 };

export const CCY_PAIR_SORT: any = (a, b) => {
  if (a.isEdited === b.isEdited) {
    return a.ccyPairIdentifier.toLowerCase() < b.ccyPairIdentifier.toLowerCase()
      ? -1
      : a.ccyPairIdentifier.toLowerCase() > b.ccyPairIdentifier.toLowerCase()
      ? 1
      : 0;
  } else {
    if (a.isEdited) return -1;
    else if (b.isEdited) return 1;
    else
      return a.ccyPairIdentifier.toLowerCase() < b.ccyPairIdentifier.toLowerCase()
        ? -1
        : a.ccyPairIdentifier.toLowerCase() > b.ccyPairIdentifier.toLowerCase()
        ? 1
        : 0;
  }
};

export const EXCLUDEDTENORS: Array<string> = ["EMPTY", "ALL"];
export const EXCLUDED_TENORS_NDF_DEFAULTS: Array<number> = [
  CubiqTS.Tenor.EMPTY,
  CubiqTS.Tenor.ALL,
  CubiqTS.Tenor.TDY,
  CubiqTS.Tenor.TOM,
  CubiqTS.Tenor.SPOT,
  CubiqTS.Tenor.Y6,
  CubiqTS.Tenor.Y7,
  CubiqTS.Tenor.Y8,
  CubiqTS.Tenor.Y9,
  CubiqTS.Tenor.Y10,
];
export const EXCLUDED_TENORS_SPOT_DEFAULTS: Array<number> = [
  CubiqTS.Tenor.EMPTY,
  CubiqTS.Tenor.ALL,
  CubiqTS.Tenor.Y6,
  CubiqTS.Tenor.Y7,
  CubiqTS.Tenor.Y8,
  CubiqTS.Tenor.Y9,
  CubiqTS.Tenor.Y10,
];

export const LIMIT_NOTIFICATION_TYPES: Set<BFXNotificationType> = new Set([
  BFXNotificationType.ACCEPTANCE_NEEDED,
  BFXNotificationType.ACTIVATED,
  BFXNotificationType.ACTIVATING,
  BFXNotificationType.CANCELLED,
  BFXNotificationType.DEAL_FAILURE,
  BFXNotificationType.LIMITALGO_ORDER_ENTERED,
  BFXNotificationType.EXPIRED,
  BFXNotificationType.EXPIRING,
  BFXNotificationType.FILLED,
  BFXNotificationType.PART_FILLED,
  BFXNotificationType.HOT,
  BFXNotificationType.MODIFIED,
  BFXNotificationType.SUSPENDED,
  BFXNotificationType.SUSPENDING,
  BFXNotificationType.TRIGGERED,
  BFXNotificationType.UNSOLICITED_CANCEL,
  BFXNotificationType.UNSOLICITED_CANCEL_MIGRATED,
  BFXNotificationType.UNSOLICITED_PAUSE_RESUME,
]);

export const BMARK_NOTIFICATION_TYPES: Set<BFXNotificationType> = new Set([
  BFXNotificationType.BMARK_SOFT_CUT_OFF,
  BFXNotificationType.BMARK_HARD_CUT_OFF,
  BFXNotificationType.BMARK_TRIGGERED,
  BFXNotificationType.BMARK_ORDER_ENTERED,
  BFXNotificationType.BMARK_NEW_ORDERS,
  BFXNotificationType.BMARK_DEAL_FAILURE,
  BFXNotificationType.BMARK_CANCELLED,
  BFXNotificationType.BMARK_MODIFIED,
  BFXNotificationType.BMARK_FILLED,
]);

export const GENERAL_NOTIFICATION_TYPES: Set<BFXNotificationType> = new Set([
  BFXNotificationType.DEALER_INTERVENTION,
  BFXNotificationType.STREAM_OFF,
  BFXNotificationType.CONNECTION_MONITOR,
]);

export const ALGO_NOTIFICATION_TYPES: Set<BFXNotificationType> = new Set([
  BFXNotificationType.ALGO_ACCEPTANCE_NEEDED,
  BFXNotificationType.ALGO_ACTIVATED,
  BFXNotificationType.ALGO_ACTIVATING,
  BFXNotificationType.ALGO_CANCELLED,
  BFXNotificationType.ALGO_DEAL_FAILURE,
  BFXNotificationType.ALGO_EXPIRED,
  BFXNotificationType.ALGO_EXPIRING,
  BFXNotificationType.ALGO_LIMITALGO_ORDER_ENTERED,
  BFXNotificationType.ALGO_FILLED,
  BFXNotificationType.ALGO_MODIFIED,
  BFXNotificationType.ALGO_PART_FILLED,
  BFXNotificationType.ALGO_UNSOLICITED_CANCEL,
  BFXNotificationType.ALGO_UNSOLICITED_PAUSE_RESUME,
  BFXNotificationType.ALGO_INFLIGHT,
  BFXNotificationType.ALGO_INFLIGHT_FAILED,
]);
export const UNCONFIGURED_NOTIFICATION_TYPES: Set<BFXNotificationType> = new Set([
  BFXNotificationType.CLEAR_NOTIFICATION,
  BFXNotificationType.ORDER_ACTION_FAIL,
  BFXNotificationType.TRADE_ACTION_FAIL,
  BFXNotificationType.INTERVENTION_ACTION_FAIL,
  BFXNotificationType.UNLOCK,
  BFXNotificationType.PROFILE,
  BFXNotificationType.EXPORT_IMPORT,
  BFXNotificationType.MESSAGE,
  BFXNotificationType.SESSION_END,
  BFXNotificationType.GENERIC_ERROR,
  BFXNotificationType.NETTING_FAILED,
  BFXNotificationType.POSITION,
]);

export const LIMIT_APP_NOTIFICATION_TYPES: Set<BFXAppNotificationType> = new Set([
  // Limit Notifications
  BFXAppNotificationType.ACTIVATED,
  BFXAppNotificationType.CANCELLED,
  BFXAppNotificationType.EXPIRED,
  BFXAppNotificationType.FILLED,
  BFXAppNotificationType.MODIFIED,
  BFXAppNotificationType.SUSPENDED,
  BFXAppNotificationType.ENTERED,
  BFXAppNotificationType.PART_FILLED,
]);

export const BMARK_APP_NOTIFICATION_TYPES: Set<BFXAppNotificationType> = new Set([
  // BMARK NOTIFICATIONS
  BFXAppNotificationType.APP_BMARK_CANCELLED,
  BFXAppNotificationType.APP_BMARK_MODIFIED,
  BFXAppNotificationType.APP_BMARK_FILLED,
  BFXAppNotificationType.APP_BMARK_ENTERED,
]);

export const GENERAL_APP_NOTIFICATION_TYPES: Set<BFXAppNotificationType> = new Set([]);

export const ALGO_APP_NOTIFICATION_TYPES: Set<BFXAppNotificationType> = new Set([
  // Algo Notification Settings
  BFXAppNotificationType.ALGO_ACTIVATED,
  BFXAppNotificationType.ALGO_CANCELLED,
  BFXAppNotificationType.ALGO_EXPIRED,
  BFXAppNotificationType.ALGO_FILLED,
  BFXAppNotificationType.ALGO_MODIFIED,
  BFXAppNotificationType.ALGO_ENTERED,
  BFXAppNotificationType.ALGO_PART_FILLED,
]);
export const UNCONFIGURED_APP_NOTIFICATION_TYPES: Set<BFXAppNotificationType> = new Set([
  BFXAppNotificationType.APP_BMARK_NEW_ORDERS,
  BFXAppNotificationType.APP_BMARK_UNSOLICITED_CANCEL,
]);
